module.exports = __webpack_public_path__ + "img/mic-fill.4704479d.svg";